import { REMOVE_DEVICES, SET_DEVICE_DATA, SET_DEVICE_FILTER_DATA, SET_DEVICE_PERCENTAGE, SET_TOTAL_DEVICES, SET_AVAILABLE_SERIAL_NUMBERS, SET_TOTAL_FILTERED_DEVICES, SET_DEVICE_COUNT, SET_DEVICE_TYPE_COUNT } from "../types"

const initialState = {
  devices: [],
  filterDevice: [],
  totalDevices: 0,
  devicesPercentage: 0,
  availableSerialNumbers: [],
  totalFilteredDevices: 0,
  deviceSelectionCount: 0,
  deviceTypeCount: 0,
}

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DEVICE_DATA:
      return {
        ...state,
        devices: action.payload,
      }
    case SET_DEVICE_FILTER_DATA:
      return {
        ...state,
        filterDevice: action.payload,
      }
    case SET_TOTAL_DEVICES:
      return {
        ...state,
        totalDevices: action.payload,
      }
    case SET_DEVICE_PERCENTAGE:
      return {
        ...state,
        devicesPercentage: action.payload,
      }
    case SET_AVAILABLE_SERIAL_NUMBERS:
      return {
        ...state,
        availableSerialNumbers: action.payload,
      }
    case SET_TOTAL_FILTERED_DEVICES:
      return {
        ...state,
        totalFilteredDevices: action.payload,
      };
    case SET_DEVICE_COUNT:
      return {
        ...state,
        deviceSelectionCount: action.payload,
      };
    case SET_DEVICE_TYPE_COUNT:
      return {
        ...state,
        deviceTypeCount: action.payload,
      };
    case REMOVE_DEVICES:
      return {
        devices: [],
        totalDevices: 0,
        filterDevice: [],
        devicesPercentage: 0,
        availableSerialNumbers: [],
      }
    default:
      return state
  }
}

export default deviceReducer
